import React from 'react';
import BasicCard from '../../../../components/card/basiccard/BasicCard';
import PreLoginLeftColumn from '../preloginleftcolumn/PreLoginLeftColumn';
import styles from './PreLoginLayout.styles';

export default function PreLoginLayout({ children }) {
    return (
        <div style={styles.mainContainer}>
            <div style={styles.twoColumn}>
                <div style={styles.leftColumn}>
                    <PreLoginLeftColumn />
                </div>
                <div style={styles.rightColumn}>
                    <BasicCard customStyles={styles.loginBox}>
                        {children}
                    </BasicCard>
                </div>
            </div>
        </div>
    )
}